import { type FC } from 'react';
import useSimDetails from 'api/sims/useSimDetails';
import useSimProfiles from 'api/sims/useSimProfiles';
import Field from 'components/Field/Field';

interface PublicIpAddressFieldProps {
  hologramSimId?: HologramSimId;
}

const PublicIpAddressField: FC<PublicIpAddressFieldProps> = ({ hologramSimId }) => {
  const { simDetails, error } = useSimDetails(hologramSimId);
  const { simProfiles, error: simProfilesError } = useSimProfiles(hologramSimId);

  if (error || simProfilesError) {
    return null;
  }

  let publicIpAddress;
  let activeProfile;
  if (simDetails.activeProfileIccid && simDetails.activeProfileIccid.length > 0) {
    activeProfile = simProfiles.find((profile) => profile.iccid === simDetails.activeProfileIccid);
    publicIpAddress = activeProfile?.publicIpAddress;
  }

  if (!publicIpAddress) return null;

  return <Field label="Public IP address" value={publicIpAddress} />;
};

export default PublicIpAddressField;
